import { render } from "./PretensionsList.vue?vue&type=template&id=0fa80336&scoped=true&ts=true"
import script from "./PretensionsList.vue?vue&type=script&lang=ts"
export * from "./PretensionsList.vue?vue&type=script&lang=ts"

import "./PretensionsList.vue?vue&type=style&index=0&id=0fa80336&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa80336"]])

export default __exports__